const lastKeyInMap = (map: Map<string, Object>) => Array.from(map.keys()).pop();
export default lastKeyInMap;
